var _rect, _path, _circle, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKycRequirementInfoIcon = function SvgKycRequirementInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 28,
    height: 20,
    rx: 2,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 24a4 4 0 0 1 4-4h3a4 4 0 0 1 4 4v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1Z",
    fill: "#069BAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 16.5,
    r: 3.5,
    fill: "#76CDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.562 23.967v.297a2.078 2.078 0 0 0 2.078 2.078h7.717a2.078 2.078 0 0 0 2.078-2.078v-.297a4.625 4.625 0 0 0-3.36-4.556 3.858 3.858 0 1 0-5.153 0 4.625 4.625 0 0 0-3.36 4.556Zm5.937-10.092a2.672 2.672 0 1 1 0 5.343 2.672 2.672 0 0 1 0-5.344Zm-1.188 6.53h2.375a3.483 3.483 0 0 1 3.562 3.562v.297a.89.89 0 0 1-.89.89H5.64a.89.89 0 0 1-.89-.89v-.297a3.484 3.484 0 0 1 3.561-3.562Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.902 19.811a.593.593 0 0 0-.593.594v7.42a.89.89 0 0 1-.89.891H2.077a.89.89 0 0 1-.89-.89V10.609a.89.89 0 0 1 .89-.89h13.06a.594.594 0 1 0 0-1.188H2.079A2.078 2.078 0 0 0 0 10.61v17.217a2.078 2.078 0 0 0 2.078 2.078h24.34a2.078 2.078 0 0 0 2.078-2.078v-7.421a.594.594 0 0 0-.594-.594Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 12.154 17 6.269 24.333 3 31 6.27l-.667 5.23L29 15.423 23.667 20l-3.334-2.615-2-2.616-.666-2.615Z",
    fill: "#B4E1E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m27.383 8.706-3.734 3.735-2.351-2.351a.594.594 0 0 0-.84.84l2.77 2.77a.594.594 0 0 0 .84 0l4.155-4.156a.594.594 0 0 0-.84-.838Z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.547 5.406a.594.594 0 0 0-.54-.528 11.96 11.96 0 0 1-3.283-.915 11.654 11.654 0 0 1-2.983-1.807.594.594 0 0 0-.801 0 11.63 11.63 0 0 1-2.984 1.807c-1.04.458-2.139.766-3.265.915a.594.594 0 0 0-.543.528c-.027.252-.62 6.18.846 9.107 1.754 3.496 5.937 5.459 6.112 5.542a.593.593 0 0 0 .499 0c.175-.083 4.357-2.046 6.111-5.542 1.452-2.927.858-8.855.831-9.107Zm-1.908 8.576c-1.333 2.662-4.408 4.405-5.299 4.87-.89-.465-3.965-2.208-5.298-4.87-1.093-2.185-.873-6.558-.766-7.988a14.037 14.037 0 0 0 3.146-.938c1.04-.44 2.02-1.008 2.918-1.692a13.484 13.484 0 0 0 2.918 1.692c1.009.434 2.065.75 3.147.938.11 1.43.33 5.803-.766 7.988ZM18.404 26.342h5.936a.594.594 0 1 0 0-1.188h-5.936a.594.594 0 1 0 0 1.188ZM18.404 22.78h3.562a.593.593 0 1 0 0-1.188h-3.562a.594.594 0 1 0 0 1.188Z",
    fill: "#000"
  })));
};
export default SvgKycRequirementInfoIcon;